export const FILTER_MENU_MIN_WIDTH = 168;
export const FILTER_MENU_MIN_WIDTH_ON_NESTED = 200;
export const FILTER_MENU_MAX_WIDTH = 384;

export const FILTER_SEARCH_THRESHOLD = 9;

export const OPEN_CHANGE_PAYLOAD = { action: 'clicked', actionSubject: 'dropdownMenu' };
export const OPEN_CHANGE_SUBJECT_ID = 'filterList';

export const MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD = 9;
